import Vue from "vue";
import VueRouter from "vue-router";
import pcRouter from "./pcRouter";
import mobileRouter from "./mobileRouter";

Vue.use(VueRouter);
const ISMOBILE = function() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
};
// const routes = [...pcRouter, ...mobileRouter];
const routes = ISMOBILE() ? mobileRouter : mobileRouter;

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();

  //当移动端试图访问pc端页面时
  // if (/Android |webos| iPhone |iPod| BlackBerry | iPad/i.test(navigator.userAgent) && to.meta.type != 'mobile' ){
  //   const routers = router.options.routes.filter(v => v.name === 'm_index')[0].children;
  //   let path =""
  //   routers.filter((item)=>{
  //       if(item.name.split('_')[1] === to.path.split('_')[1]){
  //         path = item.path
  //       }
  //   })
  //   if (path) {
  //     next(path);
  //   }else{
  //     next('/');
  //   }
  // }
  //   //当pc端页面试图访问移动端页面时
  //   if (!/Android | webos | iPhone | iPod | BLackBerry | iPad/i.test(navigator.userAgent) && to.meta.type !== 'pc'){
  //       const routers= router.options.routes.filter(v => v.name  === 'p_index')[0].children;
  //       let path =""
  //       routers.filter((item)=>{
  //           if(item.name.split('_')[1] === to.path.split('_')[1]){
  //             path = item.path
  //           }
  //       })
  //    if(path){
  //       next(path);
  //    }else {
  //       next ('/');
  //    }
  //   }
  //   next();
});

export default router;
